export default [
  {
    path: "/dashboard",
    name: "Dashboard",
    hidden: true,
    component: () => import("@/views/admin/dashboard/Dashboard.vue"),
    meta: {
      title: "Dashboard",
      noCache: true,
    },
  },

  {
    path: "/orders",
    name: "Orders",
    hidden: true,
    component: () => import("@/views/admin/orders/Orders.vue"),
    meta: {
      title: "Orders",
      noCache: true,
    },
  },
  {
    path: "/ordershistory",
    name: "OrdersHistory",
    hidden: true,
    component: () => import("@/views/admin/ordershistory/OrdersHistory.vue"),
    meta: {
      title: "Orders History",
      noCache: true,
    },
  },
  {
    path: "/customers",
    name: "Customers",
    hidden: true,
    component: () => import("@/views/admin/customers/Customers.vue"),
    meta: {
      title: "Customers",
      noCache: true,
    },
  },
  {
    path: "/customers/:id",
    name: "customer-detail",
    component: () => import("@/views/admin/customers/CustomerDetail.vue"),
    props: true,
    meta: {
      title: "Customers",
      noCache: true,
    },
  },
  {
    path: "/qrcodes",
    name: "qrcodes",
    hidden: true,
    component: () => import("@/views/admin/qr-code/QrCodes.vue"),
    meta: {
      title: "qrcodes",
      noCache: true,
    },
  },
  {
    path: "/menus",
    name: "Menus",
    hidden: true,
    component: () => import("@/views/admin/menus/Menus.vue"),
    meta: {
      title: "Menus",
      noCache: true,
    },
  },
  {
    path: "/menu-management",
    name: "Menu Management",
    hidden: true,
    component: () => import("@/views/admin/menus/MenuManagement.vue"),
    meta: {
      title: "Menu Management",
      noCache: true,
    },
  },
  {
    path: "/account",
    name: "ManageAcount",
    redirect: "/account/companies",
    meta: {
      title: "Manage Acount",
    },
    children: [
      {
        path: "companies",
        name: "Companies",
        component: () => import("@/views/admin/account/Companies.vue"),
        meta: {
          title: "Companies",
          noCache: true,
        },
      },
      {
        path: "stores",
        name: "Stores",
        hidden: true,
        component: () => import("@/views/admin/account/Stores.vue"),
        meta: {
          title: "Stores",
          noCache: true,
        },
      },
      {
        path: "layouts",
        name: "Layouts",
        hidden: true,
        component: () => import("@/views/admin/account/Layouts.vue"),
        meta: {
          title: "Layouts",
          noCache: true,
        },
      },
      {
        path: "settings",
        name: "Settings",
        hidden: true,
        component: () => import("@/views/admin/account/Settings.vue"),
        meta: {
          title: "Settings",
          noCache: true,
        },
      },
      {
        path: "campaign-manager",
        name: "CampaignManager",
        hidden: true,
        component: () => import("@/views/admin/account/CampaignManager.vue"),
        meta: {
          title: "Campaign manager",
          noCache: true,
        },
        children: [
          {
            path: "campaign",
            name: "Campaign",
            component: () => import("@/views/admin/account/Campaigns.vue"),
            meta: {
              title: "Campaign",
              noCache: true,
            },
          },
          {
            path: "promo",
            name: "Promo",
            component: () => import("@/views/admin/account/Promotions.vue"),
            meta: {
              title: "Promo",
              noCache: true,
            },
          },
          {
            path: "automations",
            name: "Automations",
            component: () => import("@/views/admin/account/Automations.vue"),
            meta: {
              title: "Automations",
              noCache: true,
            },
          },
          {
            path: "sms-marketing",
            name: "SMSMarketing",
            component: () => import("@/views/admin/account/SmsMarketing.vue"),
            meta: {
              title: "SMS Marketing",
              noCache: true,
            },
          },
          {
            path: "text-to-buy",
            name: "TextToBuy",
            component: () => import("@/views/admin/account/TextToBuy.vue"),
            meta: {
              title: "Text to buy",
              noCache: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/storedetails",
    name: "StoreDetails",
    hidden: true,
    component: () => import("@/views/admin/store/StoreDetails.vue"),
    meta: {
      title: "Store Details",
      noCache: true,
    },
  },
  {
    path: "/marketing",
    name: "Marketing",
    hidden: true,
    component: () => import("@/views/admin/marketing/Marketing.vue"),
    meta: {
      title: "Marketing",
      noCache: true,
    },
  },
  {
    path: "/refunds",
    name: "Refunds",
    hidden: true,
    component: () => import("@/views/admin/refunds/Refunds.vue"),
    meta: {
      title: "Refunds",
      noCache: true,
    },
  },
];
